import { render, staticRenderFns } from "./CreateMain.vue?vue&type=template&id=0daf0b52&"
import script from "./CreateMain.vue?vue&type=script&lang=js&"
export * from "./CreateMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports